import { render } from "./NavigationLink.vue?vue&type=template&id=2550c7f4&ts=true"
import script from "./NavigationLink.vue?vue&type=script&lang=ts"
export * from "./NavigationLink.vue?vue&type=script&lang=ts"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__